import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { putErrorNotification } from '../../../../../../../utils/saga';
import { initialize, initializeSuccess, initializeError } from '../actions';
import type { PapiDaSharedDeviationSubmitInit } from '@wix/da-papi-types';

function* initializeSaga(action: ReturnType<typeof initialize>): SagaIterator {
  const {
    payload: { deviationId },
  } = action;

  const response: PapiDaSharedDeviationSubmitInit = yield call(requestPuppy, {
    method: 'get',
    url: '/deviation/submit/init',
    params: {
      deviationid: deviationId,
    },
  });

  if (!response || !response.deviation || isApiError(response)) {
    const errorMessage = 'Failed to initialize boost';
    yield putErrorNotification(errorMessage);
    yield put(initializeError(errorMessage));

    return;
  }

  // Store the deviation directly in the boost modal store slice
  const payload = {
    deviation: response.deviation,
    tags: response.tags?.map(tag => tag.name) || [],
    recommendedTags: response.recommendedTags?.map(tag => tag.name) || [],
  };

  yield put(initializeSuccess(payload));
}

export default function* boostSaga() {
  yield takeEvery(initialize, initializeSaga);
}
